/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { object, shape, string } from 'prop-types';
import Media from 'react-media';
import { compose } from 'recompose';
import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import MobileSubscriptions from './MobileSubscriptions/MobileSubscriptions';
import DesktopSubscrioptions from './DesktopSubscriptions/DesktopSubscriptions';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import configENV from '../../config';
import { trackPage } from '../../../../helpers/tracking/common/commonTrackingHelpers';
import GraphqlSeoHeadTags from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const { PERSIST_KEY } = configENV;

class Subscriptions extends Component {
    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    render() {
        const seo = {
            page_title: 'My Account',
            location: { pathname: '/account/subscriptions' },
        };
        const { userProfile, featureFlags } = this.props;
        const breakpointExpr =  `(max-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;
        return (
            <>
                <GraphqlSeoHeadTags seoData={seo} />
                <Media query={breakpointExpr}>
                    {(matches) => (
                        matches ? (
                            <MobileSubscriptions userProfile={userProfile} featureFlags={featureFlags} />
                        ) : (
                            <DesktopSubscrioptions userProfile={userProfile} featureFlags={featureFlags} />
                        )
                    )}
                </Media>
            </>
        );
    }
}

Subscriptions.defaultProps = {
    userProfile: {},
    featureFlags: {},
};

Subscriptions.propTypes = {
    userProfile: shape({
        userRole: string.isRequired,
        email: string.isRequired,
        XAtt4: string.isRequired,
        XAtt5: string.isRequired,
    }),
    featureFlags: object,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isFetchingModal: newState.isFetchingModal,
        addFormLable: newState.addFormLable,
        addForm: newState.addForm,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchUserProfile: () => dispatch(EventDispatcher.fetchUserProfile()),
});

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    trackPage({
        type: 'subscription',
        name: 'MyAccount',
        accountPage: true,
    }),
    withPageView({
        pageViewSuccessTest: () => true,
    }),
);
export default enhance(Subscriptions);
